import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Student_Get_One_Nested_Prop_From_MongoDB(
  dbName,
  collctiontext,
  id,
  prop,
  setdata,
  logoutStudent
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/student/Student_Get_One_From_MongoDB",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("StudentToken")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Student_id"),
            activitylog: "No",
            aboutid: id,
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logoutStudent();

        return; // Stop further execution in case of invalid auth token
      }
      //Check if nothing found
      if (response.data.data.length === 0) {
        window.alert(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
        console.log(
          "Error, No data found matching your search. Please try again or get Admin support"
        );
      } else {
        // if response.data.data[0][prop] is an object
        if (typeof response.data.data[0][prop] === "object") {
          setdata(response.data.data[0][prop]); // Update your state with the fetched data
        } else {
          setdata({});
        }
        // setdata(response.data.data[0][prop]); // Update your state with the fetched data
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to InvestIN via info@investin.org if this issue persists: ",
        error
      );
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
